import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getTrack360ApiUrl } from '@app/pages/checkout-app/utils';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class Track360Api {
  private readonly API_URL = getTrack360ApiUrl();
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
  ) {}

  get(path: string, options = {}): Observable<any> {
    return this.http.get(this.API_URL + path, { ...options, headers: this.getHeaders() });
  }
  public getHeaders(options?) {
    return {
      Authorization: `Bearer ${this.apiService.jwtToken}`,
    };
  }
}
